import * as React from "react";
import { Colors } from "../../../styles/variables/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IReactSelectOptionObject } from "@atman/business";
import { OptionProps, components } from "react-select";

export interface ICheckMarkOptionProps<TValue = IReactSelectOptionObject> extends OptionProps<TValue> {}

export const CheckMarkOption: React.FC<ICheckMarkOptionProps> = (props) => {
    const { children, ...otherProps } = props;

    return (
        <components.Option {...otherProps}>
            {children}
            {props.isSelected && (
                <FontAwesomeIcon
                    icon={["far", "check"]}
                    style={{ justifySelf: "flex-end" }}
                    color={Colors.greyShades.shade3}
                />
            )}
        </components.Option>
    );
};
